// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".r5VW_IVPKRK1irFt9slA{background:rgba(0,0,0,.3);border-radius:4px;font-size:0}.IhdhlvJ5Us46rAvxAtgP{filter:\"drop-shadow(rgba(0, 0, 0, 0.5) 0px 1px 1px)\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": "r5VW_IVPKRK1irFt9slA",
	"iconStyle": "IhdhlvJ5Us46rAvxAtgP"
};
export default ___CSS_LOADER_EXPORT___;
